import { Link } from "react-router-dom";
import { Instagram, MessageCircle, MapPin, Phone, Mail } from "lucide-react";
import Logo from "./Logo";
import { SITE, waLink, PLAY_FIRST_WA } from "@/config/site";

export default function Footer() {
  return (
    <footer className="bg-ink text-paper" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div className="space-y-4">
          <Logo light />
          <p className="text-paper/60 text-sm leading-relaxed max-w-xs text-justify">
            A School of Music in Sion, Mumbai: Guitar, Keyboard, Violin, Flute, Singing, Songwriting and Composition. Structured, hands-on and fun, the Highway way.
          </p>
          <div className="flex gap-3">
            <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Instagram" className="w-10 h-10 rounded-full border border-paper/15 flex items-center justify-center hover:bg-brand hover:border-brand transition-colors duration-300">
              <Instagram size={16} />
            </a>
            <a href={waLink(PLAY_FIRST_WA)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" aria-label="WhatsApp" className="w-10 h-10 rounded-full border border-paper/15 flex items-center justify-center hover:bg-brand hover:border-brand transition-colors duration-300">
              <MessageCircle size={16} />
            </a>
          </div>
        </div>
        <div>
          <p className="text-xs tracking-[0.25em] text-gold font-bold mb-5">EXPLORE</p>
          <nav className="flex flex-col gap-2.5 text-sm">
            <Link to="/courses" data-testid="footer-link-courses" className="text-paper/70 hover:text-gold transition-colors">Courses</Link>
            <Link to="/tmh-unplugged" data-testid="footer-link-unplugged" className="text-paper/70 hover:text-gold transition-colors">TMH Unplugged</Link>
            <Link to="/play-first-pay-later" data-testid="footer-link-fitness-check" className="text-paper/70 hover:text-gold transition-colors">Trial Sessions</Link>
            <Link to="/founder" data-testid="footer-link-founder" className="text-paper/70 hover:text-gold transition-colors">About the Founder</Link>
            <Link to="/testimonials" data-testid="footer-link-testimonials" className="text-paper/70 hover:text-gold transition-colors">Student Stories</Link>
            <Link to="/life" data-testid="footer-link-life" className="text-paper/70 hover:text-gold transition-colors">Life on Music Highway</Link>
            <Link to="/whatsapp-inquiry" data-testid="footer-link-inquiry" className="text-paper/70 hover:text-gold transition-colors">Quick Inquiry Response</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="text-paper/70 hover:text-gold transition-colors">Studio & Location</Link>
            <Link to="/privacy" data-testid="footer-link-privacy" className="text-paper/70 hover:text-gold transition-colors">Privacy Policy</Link>
          </nav>
        </div>
        <div>
          <p className="text-xs tracking-[0.25em] text-gold font-bold mb-5">VISIT THE STUDIO</p>
          <p className="text-paper/70 text-sm leading-relaxed flex gap-2">
            <MapPin size={16} className="shrink-0 mt-0.5 text-brand" />
            {SITE.address}
          </p>
          <p className="text-paper/50 text-sm mt-3 text-justify"><span className="font-bold text-paper/70">Studio Timings:</span> {SITE.timings}</p>
          <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-1.5 text-paper/60 text-sm mt-2 hover:text-gold transition-colors">
            <Mail size={13} /> {SITE.email}
          </a>
          <a href={`tel:+91${SITE.whatsapp.slice(2)}`} data-testid="footer-phone-link" className="flex items-center gap-1.5 text-paper/60 text-sm mt-1.5 hover:text-gold transition-colors">
            <Phone size={13} /> {SITE.phoneDisplay}
          </a>
        </div>
      </div>
      <div className="border-t border-paper/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-paper/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.fullName}. All rights reserved.</span>
          <span className="tracking-widest">SION EAST · MUMBAI</span>
        </div>
      </div>
    </footer>
  );
}
